export default "__VITE_ASSET__8a329f44__"